<template>
    <div>
        <mt-popup v-model="popupVisible" position="top" :closeOnClickModal="false">
            <section class="bg_fff chooseBox">
                <p v-if="subTitle" class="fs12 co_666">{{ subTitle }}</p>
                <p v-for="item in renderData" :key="item" class="flex_box listItem" @click="chooseOne(item)">
                    <span class="flex_1">{{ item }}</span><img v-show="selectedOption === item" src="../../assets/img/icon/selectActive.png" alt="确认选中">
                </p>
            </section>
        </mt-popup>
    </div>
</template>

<script>
import utils from "@/util/const";

export default {
    name: "EventChoose",
    props: {
        popupVisible: Boolean, // 是否显示选择弹窗
        renderType: String,
        activeOption: String,
    },
    data() {
        return {
            eventData: ['全部事件', '敏感事件', '中性事件', '正面事件', ],
            timeData: ['今日', '近7日', '本月', '最近三月', ],
            industryData: [],
            selectedOption: '',
            renderData: [],
            tendencyData: utils.tendencies.map(item => item.label),
            subTitle: null
        }
    },
    watch: {
        'renderType': function(value) {
            this.setData(value)
        }
    },
    mounted() {
        let industries = [{key: '金融业', label: '全行业'}].concat(utils.subIndustries);
        this.industryData = industries.map(item => item.label)
        let type = this.renderType;
        this.setData(type)
    },
    methods: {
        setData(type) {
            this.renderData = this[type + 'Data']
            this.subTitle = type === 'event' ? '事件类型' : type === 'industry' ? '选择行业' : type === 'tendency' ? '选择报道倾向' : null;
            this.selectedOption = this.activeOption;
        },
        chooseOne(item) {
            this.selectedOption = item;
            let params = {
                keyword: this.renderType + 'Active',
                value: item,
            }
            this.$emit('selectedOption', params)
        }
    },
}
</script>

<style lang="scss" scoped>
.chooseBox {
    width: 100vw;
    padding: 16px;
    margin-top: 57px;
    .listItem {
        margin-top: 16px;
        padding-left: 8px;
        img {
            width: 16px;
            height: 16px;
        }
    }
}
</style>